import { ColumnDetails } from '../../grid/types/common';
import { Column, ColumnKeys } from '../integrityMonitorRules/integrityMonitorRulesGrid/types';
import { html } from 'lit';
import { getSeverityWithBullet } from './utils/helpers';

export function severityRenderer(rowData, columnDetails: ColumnDetails<Column, ColumnKeys>) {
  const cellValue = rowData.item[columnDetails.key];
  const { bullet, severityLabel } = getSeverityWithBullet(this.dependencies.translateFn, cellValue);

  return html`<span class="cell-label has-bullet ${bullet}">${severityLabel}</span>`;
}
